import { parseDate } from './format';
import { Occasions } from '@/types/occasion';

export const filterOccasions = (occasions: Occasions[]) => {
  if (!occasions) return [];
  const validOccasions: Occasions[] = [];
  occasions.forEach((occasion) => {
    const endTime = parseDate(occasion?.end_time);
    const startTime = parseDate(occasion?.start_time);

    const currentTime = new Date();

    if (currentTime >= startTime && currentTime <= endTime && !occasion?.preorder_only) {
      occasion.isPreorder = false;
      validOccasions.push(occasion);
    }
  });
  const filteredOccasions = occasions.filter(
    (occasion) => !validOccasions.map((occasion) => occasion.id).includes(occasion.id)
  );

  filteredOccasions.forEach((occasion) => {
    const currentTime = new Date();
    const preorderStartTime = new Date(parseDate(occasion?.preorder_start_time));
    const preorderEndTime = new Date(parseDate(occasion?.preorder_end_time));

    if (currentTime >= preorderStartTime && currentTime <= preorderEndTime) {
      occasion.isPreorder = true;
      validOccasions.push(occasion);
    }
  });

  return validOccasions;
};
